module.exports = __webpack_public_path__ + "img/@work_titleistM_list.a7b4a364.png";